<ion-content class="modal-outher-container">
  <ion-grid class="modal-container">
    <ion-row class="content-padding-vertical" justify-content-center>
      <ion-col>
        <app-modal-header
          header="{{ 'EDIT' | translate }}"
          (close)="onCloseModal()"
          *ngIf="editAssignment"
        >
        </app-modal-header>
        <app-modal-header
          header="{{ 'SPACE.SHARE' | translate }}"
          (close)="onCloseModal()"
          *ngIf="!editAssignment"
        >
        </app-modal-header>

        <ion-item
          lines="none"
          class="user-assignment-view-share__subtile"
          *ngIf="!editAssignment"
        >
          <ion-text>
            {{ "SPACE.PROVIDE_SPACE_TO_POOL" | translate }}
          </ion-text>
          <ion-icon
            src="../../../../../../assets/icons/info.svg"
            (click)="onShowPopover($event)"
            class="user-assignment-view-share__info-icon "
          ></ion-icon>
        </ion-item>

        <form [formGroup]="form" (ngSubmit)="onShareUserAssignment()">
          <ion-grid fixed>
            <ion-row>
              <ion-col size="12" size-md="6">
                <div class="control-display margin-top-0">
                  <ion-label>{{ "SPACE.START" | translate }}:</ion-label>
                  <app-date-time-picker
                    [value]="startDate"
                    placeholder="{{ 'ADD_INVITATION.SELECT_DATE' | translate }}"
                    [min]="
                      editAssignment
                        ? timeOptions.minDate
                        : assignmentDetails.dateFrom
                    "
                    [max]="
                      editAssignment
                        ? timeOptions.maxDate
                        : assignmentDetails.dateTo
                    "
                    (afterPickerClosed)="afterPickerClosed($event, 'start')"
                  ></app-date-time-picker>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6">
                <div class="control-display margin-top-0">
                  <ion-label>{{ "SPACE.END" | translate }}:</ion-label>
                  <app-date-time-picker
                    placeholder="{{ 'ADD_INVITATION.SELECT_DATE' | translate }}"
                    [value]="endDate"
                    [min]="
                      editAssignment
                        ? timeOptions.minDate
                        : assignmentDetails.dateFrom
                    "
                    [max]="
                      editAssignment
                        ? timeOptions.maxDate
                        : assignmentDetails.dateTo
                    "
                    (afterPickerClosed)="afterPickerClosed($event, 'end')"
                  ></app-date-time-picker>
                </div>
              </ion-col>
            </ion-row>
            <ion-row
              *ngIf="
                ((form.get('dateFrom').touched || form.get('dateTo').touched) &&
                  form.hasError('startDateBigger')) ||
                (validationError && form.hasError('startDateBigger'))
              "
            >
              <ion-col>
                <ion-label color="danger" class="font-size__16">
                  {{ "SPACE.START_LATER_THAN_END" | translate }}
                </ion-label>
              </ion-col>
            </ion-row>
            <ng-container *ngIf="!editAssignment">
              <ion-row>
                <ion-col>
                  <ion-item lines="none" class="ion-no-padding">
                    <ion-label
                      class="display-flex-important ion-align-items-center"
                    >
                      {{ "SPACE.OR_PROVIDE_SPACE_TO_A_PERSON" | translate }}
                      <ion-toggle
                        (ionChange)="onToggleSelectUser()"
                      ></ion-toggle>
                    </ion-label>
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row [ngClass]="{ disabled: disableUserSelect }">
                <ion-col>
                  <app-select-user
                    [selectedUser]="userService.userStorage"
                    [disabled]="disableUserSelect"
                    class="no-margin"
                  ></app-select-user>
                </ion-col>
              </ion-row>
            </ng-container>
            <ion-row
              class="user-assignment-view-share__submit-button-container"
            >
              <ion-col>
                <ion-button type="submit" class="ion-float-right">
                  <ng-container *ngIf="editAssignment">
                    {{ "SAVE" | translate }}
                  </ng-container>
                  <ng-container *ngIf="!editAssignment">
                    {{ "SPACE.SHARE_SPACE" | translate }}
                  </ng-container>
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
